import * as React from 'react';
import { ReactElement } from 'react';

import { Flex } from './flex';

export const DUMMY_STATUSES_CLASS_NAMES = {
  Новое: 'new',
  'Ожидает заезда': 'pending-arrival',
  Заехал: 'arrived',
  Выехал: 'done',
  Отменено: 'canceled',
  Незаезд: 'not-arrived',
};

export const BOOKS_STATUSES_CLASS_NAMES = {
  Новая: 'red',
  Принята: 'orange',
  'Клиент думает': 'orange',
  Подтверждена: 'green',
  Отменена: 'blue',
  Заехал: 'green',
  Аннулирована: 'blue',
  Спам: 'blue',
  Бронирование: 'orange',
  'Ожидает заезда': 'green',
  'На аннуляцию': 'blue',
};

interface StatusLabelProps {
  dummyStatus?: string;
  status?: string;
  statusName?: string | ReactElement;
  color?: 'red' | 'orange' | 'blue' | 'green';
  className?: string;
  icon?: ReactElement;
  isBooking?: boolean;
}

export const StatusLabel: React.FC<StatusLabelProps> = (props) => {
  let className, value;

  if (props.dummyStatus) {
    className = DUMMY_STATUSES_CLASS_NAMES[props.dummyStatus];
    if (className === 'new' && !props.isBooking) {
      className = 'blue';
    }
    value = props.dummyStatus;
    if (!className) return props.dummyStatus;
  } else if (props.status) {
    className = BOOKS_STATUSES_CLASS_NAMES[props.status];
    value = props.statusName;
  } else {
    className = props.color;
    value = props.statusName;
  }

  if (props.icon) {
    return (
      <Flex gap={'small'} className={`status_label status_label__${className} ${props.className}`}>
        {props.icon}
        <div>{value}</div>
      </Flex>
    );
  } else {
    return <label className={`status_label status_label__${className} ${props.className}`}>{value}</label>;
  }
};
